import { latestSchemaVersion } from '../schema/flameSchema'
import { defineExample, tid, vid } from './util'

/**
 * Crystal Geode — faceted crystalline interior with layered depth.
 * diamond3D creates sparkling angular reflections, spherical3D adds
 * concentric layering, and cross3D provides sharp geometric accents.
 */
export const example36 = defineExample({
  version: latestSchemaVersion,
  metadata: {
    author: 'unknown',
    name: 'Crystal Geode',
    description:
      'faceted crystalline interior with layered depth. diamond3D creates sparkling angular reflections, spherical3D adds concentric layering, and cross3D provides sharp geometric accents.',
  },
  renderSettings: {
    dimensions: 3,
    exposure: -1.5,
    skipIters: 18,
    drawMode: 'light',
    colorInitMode: 'colorInitZero',
    pointInitMode: 'pointInitUnitSphere',
    vibrancy: 0.9,
    contrast: 3.8,
    gamma: 3.0,
    depthColorPower: 0.0,
    lightDirection: [-0.3, 0.7, -0.6],
    lightPower: 0.1,
    highlightPower: 1.5,
    densityEstimationQuality: 0.75,
    estimatorCurve: 0.45,
    paletteMode: 0,
    palettePhase: 0.6,
    paletteSpeed: 0.4,
    camera: { zoom: 1, position: [0, 0] },
    camera3D: {
      theta: 1.2,
      phi: 1.5,
      radius: 2.2,
      target: [0, 0, 0],
      fov: 55,
    },
  },
  transforms: {
    [tid('3d_geode_a')]: {
      probability: 0.4,
      preAffine: {
        a: 0.85,
        b: 0,
        c: 0.05,
        d: 0,
        e: 0,
        f: 0.85,
        g: -0.05,
        h: 0,
        i: 0.05,
        j: 0,
        k: 0.85,
        l: 0,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.0, y: 0.35 },
      colorSpeed: 0.35,
      variations: {
        [vid('3d_geode_a_v0')]: { type: 'diamond3D', weight: 0.9 },
        [vid('3d_geode_a_v1')]: { type: 'spherical3D', weight: 0.3 },
      },
    },
    [tid('3d_geode_b')]: {
      probability: 0.35,
      preAffine: {
        a: 0.7,
        b: 0.1,
        c: 0,
        d: 0,
        e: -0.1,
        f: 0.7,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.7,
        l: 0.1,
      },
      postAffine: {
        a: 1,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 1,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: -0.3, y: 0.1 },
      colorSpeed: 0.3,
      variations: {
        [vid('3d_geode_b_v0')]: { type: 'cross3D', weight: 0.7 },
        [vid('3d_geode_b_v1')]: { type: 'linear3D', weight: 0.5 },
      },
    },
    [tid('3d_geode_c')]: {
      probability: 0.25,
      preAffine: {
        a: 0.5,
        b: 0,
        c: 0,
        d: 0,
        e: 0,
        f: 0.5,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 0.5,
        l: 0,
      },
      postAffine: {
        a: 0,
        b: 1,
        c: 0,
        d: 0,
        e: -1,
        f: 0,
        g: 0,
        h: 0,
        i: 0,
        j: 0,
        k: 1,
        l: 0,
      },
      color: { x: 0.4, y: -0.3 },
      colorSpeed: 0.45,
      variations: {
        [vid('3d_geode_c_v0')]: { type: 'julia3D', weight: 0.6 },
        [vid('3d_geode_c_v1')]: { type: 'diamond3D', weight: 0.4 },
      },
    },
  },
})
